import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { ApiError, UnauthorizedError } from "@/lib/errors/api-error";

// A stale/missing rc_access_token surfaces as a 401 on whatever query or mutation
// happens to fire next - rather than that request's own error handler having to
// know to redirect, this one global hook catches every UnauthorizedError in the
// app and sends the user to login instead of leaving them stuck on the page.
function redirectToLoginOn401(error: unknown) {
  if (!(error instanceof UnauthorizedError)) return;
  if (typeof window === "undefined") return;
  if (window.location.pathname.startsWith("/login")) return;
  window.location.href = "/login";
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: redirectToLoginOn401 }),
  mutationCache: new MutationCache({ onError: redirectToLoginOn401 }),
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        !(error instanceof UnauthorizedError) &&
        !(error instanceof ApiError && error.status === 429) &&
        failureCount < 1,
      retryOnMount: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
